import type { QueryClient } from '@tanstack/react-query';

import { broadcastDashboardMutation, dashboardOptions } from '@/features/dashboard';

import type { CreateDashboardTabParams } from './symbol-selector.api';
import { createDashboardTab } from './symbol-selector.api';

export function createDashboardTabMutationOptions(
  queryClient: QueryClient,
  onNavigate: (dashboardName: string, tabName: string) => void
) {
  return {
    mutationFn: createDashboardTab,
    onSuccess: async (_: void, { dashboardName, tabName }: CreateDashboardTabParams) => {
      await queryClient.refetchQueries({ queryKey: dashboardOptions.all() });
      broadcastDashboardMutation();
      onNavigate(dashboardName, tabName);
    },
    onError: () => {}
  };
}
